var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { useLocalStorage } from 'src/shared/hooks';
var initialViewAsData = {
    id: '',
    careProviderId: '',
    name: '',
    timeZone: '',
};
var initialState = __assign({ viewAsEnabled: false }, initialViewAsData);
export var viewAsContext = createContext(initialState);
export var ViewAsProvider = function (_a) {
    var children = _a.children;
    var viewAsData = useLocalStorage('view_as_data', initialViewAsData, true, {
        isStringify: true,
        storageType: window.sessionStorage,
    })[0];
    return (_jsx(viewAsContext.Provider, __assign({ value: __assign(__assign({}, viewAsData), { viewAsEnabled: !!(viewAsData === null || viewAsData === void 0 ? void 0 : viewAsData.careProviderId) }) }, { children: children })));
};
export var useViewAsContext = function () {
    var state = useContext(viewAsContext);
    if (state === undefined) {
        throw new Error('useViewAsContext must be used within a ViewAsProvider');
    }
    return __assign({}, state);
};
